import getWhiteLabel from '@/utils/getWhiteLabel';

const needHelpItems = {
    users: [
        {
            title: 'Como funciona a página de usuários?',
            content: 'Aqui você pode cadastrar funcionários para acessar as operações da sua empresa na plataforma, bem como editar ou excluir usuários antigos.<br><br>Os usuários Administradores, ao contrário dos Operacionais, têm acesso às contas correntes da empresa dentro da plataforma e escolhem em qual delas a empresa receberá os pagamentos.'
        },
        {
            title: 'Ao cadastrar um novo usuário através do e-mail, aparecem os dados do usuário mas não consigo editá-los. O que posso fazer?',
            content: 'Quando isso acontece, é porque este usuário já existe em nosso sistema. Se quiser mudar as informações, você pode editá-las através da lista de usuários ou excluí-lo e criar um novo.'},
        {
            title: 'O que acontece após eu adicionar um novo usuário à minha empresa?',
            content: `A pessoa que você adicionou receberá um e-mail da ${getWhiteLabel()} convidando-a a ativar sua conta na plataforma com o nível de acesso e os dados que você definiu.`
        }
    ],
}

export default needHelpItems
